<template>
  <v-card outlined style="margin-bottom: 24px">
    <div class="d-flex justify-space-between align-items-center py-6 pl-6">
      <h5 class="text-uppercase align-self-center">Ghi chú nội bộ</h5>
      <!-- <v-btn
        text
        color="blue darken-4"
        class="pr-6 document-btn no-hover"
        plain
        style="height: 18px"
        @click="dialog = true"
      >
        <v-icon left>mdi-pencil</v-icon>
        Thêm ghi chú
      </v-btn> -->
    </div>
    <v-divider></v-divider>
    <div class="notes-list pa-6">
      <v-row>
        <v-col v-for="(note, index) in notes" :key="index" cols="12" sm="12" class="d-flex">
          <v-card class="note-card" outlined @click="openNoteDialog(note, index)" :ripple="false">
            <v-card-text>
              <div class="black--text dot-overflow" v-html="formatContent(note)"></div>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </div>
    <v-divider></v-divider>
    <div class="pa-6">
      <v-form v-bind="this.$attrs" ref="form">
        <v-textarea label="Nội dung" v-model="content" outlined class="mb-6" rows="3" hide-details=""></v-textarea>
      </v-form>
      <div class="d-flex justify-space-between">
        <v-spacer></v-spacer>
        <v-btn color="blue darken-4" class="white--text" :disabled="!content" @click="submit">TẠO GHI CHÚ</v-btn>
      </div>
    </div>
    <NoteUpdate
      :state="updateDialog"
      :note="selectedNote"
      :notes="notes"
      :index="selectedIndex"
      @closeDialog="updateDialog = false"
      @refresh="refresh"
    />
    <StudentTicketNewNote :state="dialog" :notes="notes" @closeDialog="dialog = false" @refresh="refresh" />
  </v-card>
</template>

<script>
import NoteUpdate from './NoteUpdate.vue'
import StudentTicketNewNote from './StudentTicketNewNote.vue'
import { mapActions } from 'vuex'

export default {
  data() {
    return {
      dialog: false,
      updateDialog: false,
      selectedNote: '',
      selectedIndex: -1,
      content: '',
    }
  },
  components: { NoteUpdate, StudentTicketNewNote },
  props: {
    notes: {
      type: Array,
      defualt: () => {
        return []
      },
    },
  },
  methods: {
    ...mapActions('studentTickets', ['updateStudentTicket']),
    reply() {
      this.dialog = true
    },
    close() {
      this.dialog = false
    },
    refresh() {
      this.$emit('refresh')
    },
    formatContent(content) {
      return content.replace(/\n/g, '<br />')
    },
    openNoteDialog(note, index) {
      this.selectedNote = note
      this.selectedIndex = index
      this.updateDialog = true
    },
    updateNote({ note, index }) {
      if (index === -1) {
        this.notes.push(note)
      } else {
        this.$set(this.notes, index, note)
      }
      this.updateDialog = false
      this.refresh()
    },
    async submit() {
      if (this.$refs.form.validate()) {
        this.$loading.active = true

        const updatedNotes = [...this.notes]
        updatedNotes.push(this.content)
        const data = {
          notes: updatedNotes,
        }
        const updated = await this.updateStudentTicket({ id: this.$route.params.id, ...data })
        if (updated) {
          this.$alert.success('Tạo ghi chú thành công!')
          this.refresh()
          this.resetForm()
          this.close()
        } else {
          this.$alert.error('Tạo ghi chú thất bại')
          this.$loading.active = false
        }
      }
    },
    resetForm() {
      this.content = ''
      this.$refs.form.resetValidation()
    },
  },
}
</script>

<style>
.no-hover.v-btn--plain .v-btn__content {
  opacity: 1 !important;
}

.notes-list {
  max-height: 400px;
  height: 400px;
  overflow-y: auto;
}

.note-card {
  width: 100%;
}

.dot-overflow {
  white-space: normal;
}

.file-link {
  margin-top: 8px;
}

.admin-message {
  margin-left: 50px;
}

.parent-message {
  margin-right: 50px;
}

.footer {
  padding-top: 24px;
}
</style>
